import { SystemResource } from "./../../../models/system-resources";
import { Resource, GitsContact } from "./../../../models/resources";
import { Nullable } from "../../../../../common/utils/nullable";

export class SystemResourceTypeDetails {
  systemType: String;

  constructor(systemType: String) {
    this.systemType = systemType;
  }
}

export class SystemDetails {
  systemName: String;
  systemResourceTypeDetailsList: SystemResourceTypeDetails[];

  constructor(systemName: String, systemTypeDetailsList: SystemResourceTypeDetails[]) {
    this.systemName = systemName;
    this.systemResourceTypeDetailsList = systemTypeDetailsList;
  }

  getTypes(): String[] {
    return this.systemResourceTypeDetailsList.map((systemTypeDetails) => systemTypeDetails.systemType);
  }
}

export class InformationAssetTableRecord {
  id: String;
  name: String;
  group: String;
  domain: String;
  assetOwners: String[];
  belongsToUser: Boolean;
  attributes: Record<string, string>;
  gitsContacts: Nullable<GitsContact[]>;
  systemDetailsList: SystemDetails[];
  associatedSystemResources: SystemResource[];

  constructor(resource: Resource, associatedSystemResources: SystemResource[]) {
    this.id = resource.id;
    this.name = resource.name;
    this.group = resource.group;
    this.domain = resource.domain;
    this.assetOwners = resource.ownersName() ?? [];
    this.belongsToUser = resource.belongsToUser;
    this.attributes = resource.attributes;
    this.associatedSystemResources = associatedSystemResources;
    this.systemDetailsList = this.setSystemDetailsList();
    this.gitsContacts = resource.gitsContacts;
  }

  uniqueSystemsForGivenSystemResources(): String[] {
    const systemNames = this.associatedSystemResources.map(
      (systemResource: SystemResource) => systemResource.system.name,
    );
    return Array.from(new Set(systemNames));
  }

  typesForGivenSystemName(systemName: String): String[] {
    const systemTypes = this.associatedSystemResources
      .filter((systemResource: SystemResource) => systemResource.system.name === systemName)
      .map((systemResource) => systemResource.type);

    return Array.from(new Set(systemTypes));
  }

  setSystemDetailsList(): SystemDetails[] {
    return this.uniqueSystemsForGivenSystemResources().map((systemName: String) => {
      return new SystemDetails(
        systemName,
        this.typesForGivenSystemName(systemName).map((type) => new SystemResourceTypeDetails(type)),
      );
    });
  }

  getSystemsCount() {
    return this.systemDetailsList.length;
  }

  resourceId(): string {
    return this.id.toString();
  }
}
